// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\nbutton[data-v-c9847ba2]{\r\n /*margin-left: 10px;*/\r\n    margin-top: 10px;\r\n    /*padding-top: 10px;*/\r\n    color:white;\n}\r\n", ""]);
// Exports
module.exports = exports;
